<script setup lang="ts">

//Import all layout partials
import Header from "./components/AppHeader.vue";
// import Footer from "./components/AppFooter.vue";
import Sidebar from "./components/AppSidebar.vue";
import View from "./components/AppView.vue";

</script>

<template>
    <div>
        <Header>

        </Header>
        <Sidebar>

        </Sidebar>
        <View>

        </View>
        <!-- <Footer>

        </Footer> -->
    </div>
</template>